






































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Prop, Component, Watch } from 'vue-property-decorator';
import { CSSStyleOptions } from '@libs-uuif/shared/common-types';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import CustomDropdownRows from './custom-dropdown-rows.vue';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';

const cssPrefix = 'custom-dropdown-unit';

@Component({
  components: {
    SwTextfield,
    SwScrollView,
    CustomDropdownRows,
  },
})
export default class CustomDropdownUnit extends SwExtendedVue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  options: string[];

  @Prop()
  limit: number;

  filteredOptions: string[] = this.options.slice(0, this.limit);

  @Watch('searchValue')
  searchOption() {
    this.filteredOptions = this.options
      .filter(
        each => each.toLowerCase()
        .indexOf(this.searchValue.toLowerCase()) > -1,
      )
      .slice(0, this.limit);
  }

  cssPrefix = cssPrefix;
  searchValue: string = '';

  get searchStyle(): CSSStyleOptions {
    return {
      backgroundColor: '#363636',
      color: 'white',
    };
  }

  get getValuesFieldStyle(): CSSStyleOptions {
    return { maxHeight: '220px', flex: '1' };
  }

  get value(): string {
    return this.searchValue;
  }

  set value(value) {
    this.searchValue = value;
  }

  get getAllOptions(): string[] {
    return this.filteredOptions.length > 0
      ? this.filteredOptions
      : ['No results to display'];
  }

  optionClicked(selectedOption: string) {
    if (selectedOption !== '') {
      this.$emit('optionClicked', selectedOption);
    }
  }

  created() {
    setTimeout(() => {
      const wrapper2 = document.getElementById('searchBar') as HTMLElement;
      if (wrapper2) {
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         500);
  }
}
